import { useMemo, useState } from 'react';
import { AuthApi } from '@shared/api/rest';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import useForm from './form';
import { BaseInput, Button, ErrorMessage, Spinner, Text } from '@shared/widgets';

interface SignupFormProps {
  className?: string;
}

export const SignupForm = (props: SignupFormProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [companyCode, setCompanyCode] = useState<string>();
  const [password, setPassword] = useState<string>();

  const { fields } = useForm();

  const { navigate } = useRouteHook();

  const disabled = useMemo(() => !(companyCode && password), [companyCode, password]);

  const save = () => {
    if (!companyCode) return;
    if (!password) return;
    setLoading(true);
    AuthApi.signup({ companyCode: companyCode, password: password })
      .then(() => {
        navigate(RoutePaths.success.onNavigate());
      })
      .catch((err) => {
        setError(err.message);
        // navigate('/success')
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Spinner position />}
      <form className={props.className}>
        <div className='mb-6'>
          <BaseInput placeholder={fields.companyCode.caption} onChange={setCompanyCode} value={companyCode} />
          <Text className='mt-1' weight='light' size='xs'>
            Company code was sent to your company’s e-mail after signing the agreement
          </Text>
          <ErrorMessage text={fields.companyCode.error} />
        </div>
        <div className='mb-6'>
          <BaseInput type='password' placeholder={fields.password.caption} value={password} onChange={setPassword} />
          <ErrorMessage text={fields.password.error} />
        </div>
        {error && (
          <div className='mb-1 py-2 px-3 rounded-sm flex items-center flex-nowrap justify-center border border-red'>
            <ErrorMessage text={error} />
          </div>
        )}
        <Button
          // type="submit"
          color='primary'
          fullWidth
          onClick={save}
          disabled={disabled}
        >
          {loading ? 'Loading...' : 'Register'}
        </Button>
        <div className='mt-6'>
          <Text>
            If you have questions, we are always glad to help
            <br />
            Contact us <a href='tel:+420567567'>+420 567 567</a>
          </Text>
        </div>
      </form>
    </>
  );
};
